// extracted by mini-css-extract-plugin
export var brand = "_52-9";
export var compact = "_52-6";
export var extraSmall = "_52-7";
export var icon = "_52-0";
export var large = "_52-4";
export var light = "_52-1";
export var medium = "_52-5";
export var outline = "_52-b";
export var primaryDark = "_52-a";
export var primaryLight = "_52-8";
export var primaryModern = "_52-c";
export var success = "_52-2";
export var successSolid = "_52-3";